module.exports = __webpack_public_path__ + "static/img/anmo.21465d13.png";